import { z } from "zod";
export { orchestrator as serverResponse } from "../fetchOrchestrators";

export const verificationErrorResponse = z.object({
  code: z.enum(["50178", "50193", "50245", "20034", "50211", "50329"]),
});
